var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoEpgListViewSelected = function SvgIcoEpgListViewSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EEE",
    rx: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 2.727,
    x: 11.5,
    y: 12.618,
    fill: "#000",
    rx: 1.364
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 21.818,
    height: 2.727,
    x: 5.091,
    y: 8.527,
    fill: "#000",
    rx: 1.364
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 2.727,
    x: 11.5,
    y: 16.709,
    fill: "#000",
    rx: 1.364
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 2.727,
    x: 11.5,
    y: 20.8,
    fill: "#000",
    rx: 1.364
  })));
};
export default SvgIcoEpgListViewSelected;